import { UrlQueryKey } from 'app/core/api/api-core/api-constants';
import { productImg } from 'app/core/api/product-assignment/api-product-assignment.types';
import { useGetProductByUpc } from 'app/core/api/product/api-product';
import ProductPictureOrDefault from 'app/shared/components/app-image/ProductPictureOrDefault';
import Button from 'app/shared/components/button/Button';
import Body from 'app/shared/components/typography/body/Body';
import Subheading from 'app/shared/components/typography/subheading/Subheading';
import React from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components/macro';
import ConsumerRoutePath from '../../ConsumerRoutePath';

const CompactButton = styled(Button).attrs({ slim: true })`
  margin-top: 0;
`;

export default function ProductDatabaseLookupResult(): JSX.Element {
  const { result } = useGetProductByUpc();

  if (!result) {
    // in a separate file due to having quite a different page layout
    return (
      <Redirect
        to={ConsumerRoutePath.PRODUCT_DATABASE_LOOKUP_FAILED}
      />
    );
  }
  return (
    <>
      <Subheading color="primary">Is this your product?</Subheading>
      <ProductPictureOrDefault
        productId={result.id}
        src={productImg(result)}
        alt={result.name}
        height="180px"
      />
      <Body centered bold>
        {result.name.replace('undefined', '')}
      </Body>
      <Button
        to={{
          pathname: ConsumerRoutePath.ADD_ASSIGNED_PRODUCT_DETAILS,
          query: {
            [UrlQueryKey.PRODUCT_VARIANT_ID]: result.id,
            [UrlQueryKey.PRODUCT_VARIANT_NAME]: result.name,
            [UrlQueryKey.IS_NEW_DATABASE_PRODUCT]: 'true',
          },
        }}
      >
        Yes, that's my product
      </Button>
      <CompactButton variant="text" color="inherit" navBackAction>
        No, let's try again
      </CompactButton>
    </>
  );
}
